module.exports = ".feather{width:24px;height:24px}\n"